import { get, post } from './http-calls';

export const getTcardNotes = async (TCardID) => {
    let res = await get(`TCardNotes/TCardNotes_Get?TCardID=${TCardID}`, { useAuthToken: true });
    return res;
};

export const addTcardNotes = async (TCardID, TCardNoteID, newNote, visibleToCustomer, tCardNoteReminder, tCardNoteClosed) => {
    let payload = {
        TCardNoteTCardID: TCardID,
        TCardNoteID: TCardNoteID,
        newNote: newNote,
        visibleToCustomer: visibleToCustomer,
        tCardNoteReminder: tCardNoteReminder,
        tCardNoteClosed: tCardNoteClosed
    };
    let res = await post(`TCardNotes/TCardNotes_AddUpdate`, payload, { useAuthToken: true });
    return res;
};

export const deleteTcardNote = async (TCardNoteID) => {
    let res = await post(`TCardNotes/TCardNotes_Delete?TCardNoteID=${TCardNoteID}`, {}, { useAuthToken: true });
    return res;
};
